export const PaginationSetting = {
  pageCount: 20,
};
